import React, { SyntheticEvent } from "react";
import { Form, FormField, FormGroup, Input, List } from "semantic-ui-react";

// Common
import ButtonLoadCheck from "react-lib/appcon/common/ButtonLoadCheck";

// Interface
import { BTN_ACTS, PickedState, SetProp, ProjectListType } from "./sequence/ProjectList";

// Type
type PanelProjectListProps = {
  // func
  setProp: SetProp;
  onSelectProject?: (project: any) => void;
  onSearch: () => void;
  onChangeSearch: (e: SyntheticEvent | null, data: Record<string, any>) => void;
  // data
  searchValue?: string;
  data: ProjectListType[];
  selectedProject: number | null;
} & Pick<PickedState, "buttonLoadCheck" | "errorMessage" | "successMessage">;

const RenderActiveLabel = (project: ProjectListType) => {
  const activeField = project.custom_fields?.find((f) => f.name === "Active");

  if (activeField?.value === "0") {
    return (
      <label style={{ color: "red", fontStyle: "italic" }}>
        Inactive
      </label>
    )
  }
};

const PanelProjectList = (props: PanelProjectListProps) => {
  return (
    <div style={{ height: "calc(90vh - 1rem)", borderRight: "1px solid #dbdbdb" }}>
      <Form style={{ paddingLeft: "1rem", paddingTop: "1rem", paddingRight: "1rem" }}>
        <FormGroup>
          <FormField>
            <label style={{ fontSize: "18px", fontWeight: "bold" }}>Project List</label>
          </FormField>
        </FormGroup>
        <FormGroup>
          <FormField inline width={16}>
            <label>Search</label>
            <Input
              style={{ width: "50%", marginRight: "1rem" }}
              value={props.searchValue || ""}
              onChange={props.onChangeSearch}
            />
            <ButtonLoadCheck
              // func
              setProp={props.setProp}
              onClick={props.onSearch}
              // data
              paramKey={BTN_ACTS.SEARCH}
              buttonLoadCheck={props.buttonLoadCheck?.[BTN_ACTS.SEARCH]}
              // config
              name="SEARCH"
              title="SEARCH"
              color="blue"
              size="medium"
            />
          </FormField>
        </FormGroup>
        <FormGroup>
          <FormField width={16}>
            <div style={{ overflowY: "auto", height: "72vh" }}>
              <List selection>
                {props.data.map((project) => (
                  <List.Item
                    key={project.id}
                    active={props.selectedProject === project.id}
                    onClick={() => props.onSelectProject?.(project)}
                    style={{
                      padding: "1rem",
                      borderRadius: "0px",
                      backgroundColor:
                        props.selectedProject === project.id ? "#e6f7ff" : "transparent",
                      color: props.selectedProject === project.id ? "#1677ff" : "black",
                      cursor: "pointer",
                      borderBottom: "1px solid #dbdbdb",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <label>{project.name}</label>
                      {RenderActiveLabel(project)}
                    </div>
                  </List.Item>
                ))}
              </List>
            </div>
          </FormField>
        </FormGroup>
      </Form>
    </div>
  );
};

export default PanelProjectList;
